<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="content-a" id="calibre_toc_3">Table of Contents</p>
<p class="link"> </p>
<p class="link"><a href="#/OEBPS/YourNextLevelLife_split_004">Foreword</a></p>
<p class="link"><span href="#/OEBPS/YourNextLevelLife_split_006" title="Link target outside of Sample">Introduction</span></p>
<p class="link1"><span href="#/OEBPS/YourNextLevelLife_split_008" title="Link target outside of Sample">Rule #1</span></p>
<p class="link"><span href="#/OEBPS/YourNextLevelLife_split_009" title="Link target outside of Sample">Identify Your Superpowers</span></p>
<p class="link1"><span href="#/OEBPS/YourNextLevelLife_split_012" title="Link target outside of Sample">Rule #2</span></p>
<p class="link"><span href="#/OEBPS/YourNextLevelLife_split_013" title="Link target outside of Sample">Find Your Next Level Friends</span></p>
<p class="link1"><span href="#/OEBPS/YourNextLevelLife_split_016" title="Link target outside of Sample">Rule #3</span></p>
<p class="link"><span href="#/OEBPS/YourNextLevelLife_split_017" title="Link target outside of Sample">Expand Your Horizons</span></p>
<p class="link1"><span href="#/OEBPS/YourNextLevelLife_split_020" title="Link target outside of Sample">Rule #4</span></p>
<p class="link"><span href="#/OEBPS/YourNextLevelLife_split_021" title="Link target outside of Sample">Magnetize Money</span></p>
<p class="link1"><span href="#/OEBPS/YourNextLevelLife_split_024" title="Link target outside of Sample">Rule #5</span></p>
<p class="link"><span href="#/OEBPS/YourNextLevelLife_split_025" title="Link target outside of Sample">Position Yourself like a Star</span></p>
<p class="link1"><span href="#/OEBPS/YourNextLevelLife_split_028" title="Link target outside of Sample">Rule #6</span></p>
<p class="link"><span href="#/OEBPS/YourNextLevelLife_split_029" title="Link target outside of Sample">Keep It Real</span></p>
<p class="link1"><span href="#/OEBPS/YourNextLevelLife_split_032" title="Link target outside of Sample">Rule #7</span></p>
<p class="link"><span href="#/OEBPS/YourNextLevelLife_split_033" title="Link target outside of Sample">Give Back from Day One</span></p>
<p class="link1"> </p>
<p class="link"><span href="#/OEBPS/YourNextLevelLife_split_036" title="Link target outside of Sample">Are You Leveling Up?</span></p>
<p class="link"><span href="#/OEBPS/YourNextLevelLife_split_038" title="Link target outside of Sample">Resources</span></p>
<p class="link"><span href="#/OEBPS/YourNextLevelLife_split_040" title="Link target outside of Sample">About the Author</span></p>
<div class="calibre2" id="calibre_pb_3"></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// YourNextLevelLife_split_003.vue?31cf9b97